import { render } from "./EditDynamically.vue?vue&type=template&id=16bb42d1"
import script from "./EditDynamically.vue?vue&type=script&lang=js"
export * from "./EditDynamically.vue?vue&type=script&lang=js"

import "./EditDynamically.vue?vue&type=style&index=0&id=16bb42d1&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__